import { render, staticRenderFns } from "./lvsuo.vue?vue&type=template&id=4afdf059&scoped=true"
import script from "./lvsuo.vue?vue&type=script&lang=js"
export * from "./lvsuo.vue?vue&type=script&lang=js"
import style0 from "./lvsuo.vue?vue&type=style&index=0&id=4afdf059&prod&scoped=true&lang=less"
import style1 from "./lvsuo.vue?vue&type=style&index=1&id=4afdf059&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afdf059",
  null
  
)

export default component.exports